import { defineComponent as W, computed as I, ref as X, openBlock as d, createElementBlock as n, createElementVNode as i, mergeProps as E, renderSlot as k, createTextVNode as x, toDisplayString as b, createCommentVNode as r, normalizeClass as c, createBlock as g, unref as u, withCtx as y, Fragment as C, renderList as R, createVNode as Y, withDirectives as Z, vShow as _ } from "vue";
import { RevButtonIcon as V } from "@ds/components/ButtonIcon";
import { RevCheckbox as L } from "@ds/components/Checkbox";
import O from "../CheckboxBase/CheckboxBase.vue2.js";
import { RevTooltip as ee } from "@ds/components/Tooltip";
import { usePropsValidation as te } from "../../composables/usePropsValidation.js";
import le from "../../icons/generated/IconChevronDown.vue2.js";
import ae from "../../icons/generated/IconChevronUp.vue2.js";
import de from "../../icons/generated/IconInfo.vue2.js";
import { tw as a } from "../../utils/tailwind.js";
import oe from "./components/TableSortingHeader.vue2.js";
const ne = {
  key: 0,
  class: "heading-2 m-24 text-left"
}, se = { class: "block md:table-row" }, ie = {
  key: 0,
  class: "px-16 text-start first:pl-24",
  scope: "col"
}, ce = ["id"], re = ["title"], ue = ["title"], be = ["id"], fe = ["headers"], he = { class: "body-1-bold px-16 py-12 md:hidden" }, me = ["headers"], Ie = ["id", "aria-expanded"], ge = { colspan: "100" }, ve = ["id", "aria-expanded"], xe = { colspan: "100" }, Ve = /* @__PURE__ */ W({
  name: "RevTable",
  __name: "Table",
  props: {
    caption: { default: "" },
    checkedIds: { default: () => {
    } },
    selectAllLabel: { default: "Select All" },
    showCheckboxesLabels: { type: Boolean, default: !1 },
    collection: {},
    getCollectionItemId: { type: Function, default: (e) => typeof e == "object" && e !== null && "id" in e ? e.id : "" },
    columns: {},
    stripedRows: { type: Boolean, default: !1 },
    sortOptions: { default: null },
    transparentHeader: { type: Boolean, default: !1 },
    expandLabel: { default: "Expand" },
    expandRowsByDefault: { type: Boolean, default: !1 },
    shouldMountExpandedRows: { type: Boolean, default: !1 }
  },
  emits: ["update:sortOptions", "update:checkedIds", "update:expandAll", "update:expandedRow"],
  setup(e, { expose: j, emit: M }) {
    const f = M;
    te({
      "`selectAllLabel` should be provided if `checkedIds` was chosen": () => e.checkedIds && !e.selectAllLabel,
      "collection items should have an id property or a `getCollectionItemId` method should be provided if `checkedIds` or `expandable` rows are used": () => e.checkedIds || e.collection.some((l) => l.expandable) ? e.collection.some(
        (l) => e.getCollectionItemId(l) === void 0
      ) : !1
    });
    const v = I(() => ({
      align: "end",
      key: "expand",
      label: e.expandLabel
    })), w = I(() => e.collection.length === e.checkedIds?.length), S = I(
      () => e.columns.some((l) => l.additionalDescription)
    ), U = I(() => [
      a`border-static-default-low body-1-bold border-b-1`,
      S.value ? a`h-80` : a`h-56`,
      a`hidden`,
      a`md:table-row-group`,
      e.transparentHeader ? a`bg-transparent` : a`bg-static-default-hi`
    ]), p = I(() => [
      a`bg-static-default-min`,
      a`mt-24 block`,
      a`md:border-static-default-low md:mt-0 md:table-row md:border-b-1 md:last:border-b-0`,
      e.stripedRows && a`md:even:bg-static-default-mid`
    ]), F = I(() => [
      a`px-16`,
      a`border-static-default-low flex items-center justify-between border-b-1 py-12 first:pl-24`,
      a`md:table-cell md:border-none md:py-24 md:before:content-none`,
      e.stripedRows && a`md:even:bg-static-default-mid`
    ]), H = (l) => [
      a`px-16 first:pl-24`,
      l.highlighted && a`bg-static-info-low`
    ], A = (l) => [
      a`group`,
      a`border-static-default-low border-b-1 md:border-none `,
      a`flex items-center justify-between md:table-cell`,
      e.stripedRows && !l.highlighted && a`even:bg-static-default-mid md:even:before:bg-static-default-hi even:md:bg-transparent`,
      l.highlighted && a`bg-static-info-low`
    ], z = (l) => [
      a`flex items-center`,
      l.additionalDescription && a`w-0 min-w-full`
    ], P = (l) => [
      a`mr-8 text-left`,
      l.additionalDescription && a`min-w-0 flex-1 truncate`,
      l.headerClassNames
    ], T = (l) => [
      a`flex items-center px-16 py-12 text-end md:py-24 md:text-start md:group-first-of-type:pl-24 md:group-last-of-type:pr-24`,
      l.isTabular && a`justify-end tabular-nums`,
      !l.isTabular && !l.align && a`justify-start`,
      !l.isTabular && l.align === "start" && a`justify-start`,
      !l.isTabular && l.align === "center" && a`justify-center`,
      !l.isTabular && l.align === "end" && a`justify-end`
    ];
    function q(l) {
      return e.sortOptions?.sortBy === l && e.sortOptions?.sortOrder || "UNDEFINED";
    }
    function G(l, o) {
      f("update:sortOptions", { sortBy: l, sortOrder: o });
    }
    function N() {
      if (w.value)
        f("update:checkedIds", []);
      else {
        const l = e.collection.map(
          (o) => e.getCollectionItemId(o)
        );
        f("update:checkedIds", l);
      }
    }
    function D(l) {
      if (!e.checkedIds)
        return;
      const o = e.getCollectionItemId(l);
      e.checkedIds.includes(o) ? f(
        "update:checkedIds",
        e.checkedIds.filter((t) => t !== o)
      ) : f("update:checkedIds", [...e.checkedIds, o]);
    }
    function J() {
      return e.collection.filter((o) => o.expandable).reduce((o, t) => ({
        ...o,
        [e.getCollectionItemId(t)]: e.expandRowsByDefault
      }), {});
    }
    const h = X(J()), $ = I(() => e.collection.some((l) => l.expandable !== void 0));
    function K(l) {
      const o = !h.value[e.getCollectionItemId(l)];
      h.value[e.getCollectionItemId(l)] = o, f("update:expandedRow", e.getCollectionItemId(l), o);
    }
    const B = (l) => {
      const o = e.collection.filter((t) => t.expandable);
      o.length !== 0 && (h.value = o.reduce(
        (t, m) => ({
          ...t,
          [e.getCollectionItemId(m)]: l
        }),
        {}
      ));
    };
    return j({
      expandAll: () => {
        B(!0), f("update:expandAll", !0);
      },
      collapseAll: () => {
        B(!1), f("update:expandAll", !1);
      }
    }), (l, o) => (d(), n("div", null, [
      i("table", E({
        ...$.value && { "aria-live": "polite" }
      }, { class: "text-static-default-mid body-1 w-full border-collapse border-spacing-0 border-0" }), [
        e.caption ? (d(), n("caption", ne, [
          k(l.$slots, "caption", { caption: e.caption }, () => [
            x(b(e.caption), 1)
          ])
        ])) : r("", !0),
        i("thead", {
          class: c(U.value)
        }, [
          i("tr", se, [
            e.checkedIds ? (d(), n("th", ie, [
              e.showCheckboxesLabels ? (d(), g(u(L), {
                key: 1,
                id: "table-select-all",
                "model-value": w.value,
                value: "select-all",
                "onUpdate:modelValue": N
              }, {
                label: y(() => [
                  x(b(e.selectAllLabel), 1)
                ]),
                _: 1
              }, 8, ["model-value"])) : (d(), g(u(O), {
                key: 0,
                id: "table-select-all",
                label: e.selectAllLabel,
                "model-value": w.value,
                value: "select-all",
                "onUpdate:modelValue": N
              }, null, 8, ["label", "model-value"]))
            ])) : r("", !0),
            (d(!0), n(C, null, R(e.columns, (t) => (d(), n("th", {
              id: t.key,
              key: t.key,
              class: c(H(t)),
              scope: "col"
            }, [
              i("div", {
                class: c(z(t))
              }, [
                i("span", {
                  class: c(P(t)),
                  title: t.additionalDescription ? t.label : void 0
                }, b(t.label), 11, re),
                t.isSortable ? (d(), g(oe, {
                  key: 0,
                  value: q(t.key),
                  onChange: (m) => G(t.key, m)
                }, null, 8, ["value", "onChange"])) : r("", !0),
                t.description ? (d(), g(u(ee), {
                  key: 1,
                  class: "ml-2"
                }, {
                  trigger: y(({ show: m, hide: s, ...Q }) => [
                    Y(u(V), E({ icon: u(de) }, { ref_for: !0 }, Q, {
                      size: "small",
                      variant: "ghost",
                      onBlur: s,
                      onFocusin: m,
                      onMouseleave: s,
                      onMouseover: m
                    }), null, 16, ["icon", "onBlur", "onFocusin", "onMouseleave", "onMouseover"])
                  ]),
                  default: y(() => [
                    x(" " + b(t.description), 1)
                  ]),
                  _: 2
                }, 1024)) : r("", !0)
              ], 2),
              t.additionalDescription ? (d(), n("p", {
                key: 0,
                class: "text-static-default-low caption w-0 min-w-full truncate text-left",
                title: t.additionalDescription
              }, b(t.additionalDescription), 9, ue)) : r("", !0)
            ], 10, ce))), 128)),
            $.value ? (d(), n("th", {
              key: 1,
              id: v.value.label,
              class: "px-16 text-end",
              scope: "col"
            }, b(v.value.label), 9, be)) : r("", !0)
          ])
        ], 2),
        i("tbody", null, [
          (d(!0), n(C, null, R(e.collection, (t, m) => (d(), n(C, {
            key: e.getCollectionItemId(t)
          }, [
            i("tr", {
              class: c(p.value),
              scope: "row"
            }, [
              e.checkedIds ? (d(), n("td", {
                key: 0,
                class: c(F.value),
                headers: ""
              }, [
                e.showCheckboxesLabels ? (d(), g(u(L), {
                  key: 1,
                  id: `checkbox-${e.getCollectionItemId(t)}`,
                  "model-value": e.checkedIds.includes(e.getCollectionItemId(t)),
                  value: `checkbox-${e.getCollectionItemId(t)}`,
                  "onUpdate:modelValue": (s) => D(t)
                }, {
                  label: y(() => [
                    x(b(
                      // Fallback hardcoded value for backward compatibility
                      t.rowCheckboxLabel || "Select One"
                    ), 1)
                  ]),
                  _: 2
                }, 1032, ["id", "model-value", "value", "onUpdate:modelValue"])) : (d(), g(u(O), {
                  key: 0,
                  id: `checkbox-${e.getCollectionItemId(t)}`,
                  label: t.rowCheckboxLabel || `${t?.title || e.columns[0]?.label || m}-${e.getCollectionItemId(t)}`,
                  "model-value": e.checkedIds.includes(e.getCollectionItemId(t)),
                  value: `checkbox-${e.getCollectionItemId(t)}`,
                  "onUpdate:modelValue": (s) => D(t)
                }, null, 8, ["id", "label", "model-value", "value", "onUpdate:modelValue"]))
              ], 2)) : r("", !0),
              (d(!0), n(C, null, R(e.columns, (s) => (d(), n("td", {
                key: s.key,
                class: c(A(s)),
                headers: s.key
              }, [
                i("span", he, b(s.label), 1),
                i("div", {
                  class: c(T(s))
                }, [
                  k(l.$slots, `body-${s.key}`, {
                    column: s,
                    item: t
                  }, () => [
                    x(b(t?.[s.key]), 1)
                  ])
                ], 2)
              ], 10, fe))), 128)),
              $.value ? (d(), n("td", {
                key: 1,
                class: c(A(v.value)),
                headers: v.value.label
              }, [
                i("div", {
                  class: c(T(v.value))
                }, [
                  t.expandable ? (d(), g(u(V), {
                    key: 0,
                    "alternative-text": v.value.label,
                    "aria-controls": `expand-${e.getCollectionItemId(t)}`,
                    icon: h.value[e.getCollectionItemId(t)] ? u(ae) : u(le),
                    size: "small",
                    variant: "ghost",
                    onClick: (s) => K(t)
                  }, null, 8, ["alternative-text", "aria-controls", "icon", "onClick"])) : r("", !0)
                ], 2)
              ], 10, me)) : r("", !0)
            ], 2),
            !e.shouldMountExpandedRows && h.value[e.getCollectionItemId(t)] ? (d(), n("tr", {
              key: 0,
              id: `expand-${e.getCollectionItemId(t)}`,
              "aria-expanded": h.value[e.getCollectionItemId(t)],
              class: c(p.value)
            }, [
              i("td", ge, [
                k(l.$slots, `expand-${e.getCollectionItemId(t)}`, { item: t })
              ])
            ], 10, Ie)) : e.shouldMountExpandedRows ? Z((d(), n("tr", {
              key: 1,
              id: `expand-${e.getCollectionItemId(t)}`,
              "aria-expanded": h.value[e.getCollectionItemId(t)],
              class: c(p.value)
            }, [
              i("td", xe, [
                k(l.$slots, `expand-${e.getCollectionItemId(t)}`, { item: t })
              ])
            ], 10, ve)), [
              [
                _,
                e.shouldMountExpandedRows && h.value[e.getCollectionItemId(t)]
              ]
            ]) : r("", !0)
          ], 64))), 128))
        ])
      ], 16)
    ]));
  }
});
export {
  Ve as default
};
